import { Theme, ThemeUICSSObject } from 'theme-ui';
import tinycolor from 'tinycolor2';
/* IMPORT HERE */

export const responsive: (theme: Theme) => ThemeUICSSObject = (theme) => {
  return {
    maxHeight: '100%',
    overflow: 'auto',
    position: 'relative',
    // borderRadius: '10px',

    '&.isLoading': {
      overflow: 'hidden',
    },

    '.responsiveTable__isLoading': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: tinycolor(theme.palette.background.paper)
        .setAlpha(0.7)
        .toRgbString(),
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '.cell__download__document': {
      display: 'flex',
      gap: 3,
      alignItems: 'center',
      justifyContent: 'start',

      '&, *': {
        color: 'palette.primary.main',
      },

      svg: {
        flexShrink: 0,
      },
    },
    /* PREPEND HERE */
  };
};
